import styled from 'styled-components';
import { CtaButton } from '../common-components/CtaButton';
import { HtmlZone } from '../common-components/HtmlZone';

export const CollectHtmlZone = styled(HtmlZone)`
  bottom: auto;
  height: 28vh;
`;
CollectHtmlZone.displayName = 'CollectHtmlZone';

export const DeclineCtaButton = styled(CtaButton)`
  height: 7vh;
  right: 20vw;
  left: 20vw;
  bottom: 19vh;
`;
DeclineCtaButton.displayName = 'DeclineCtaButton';
